/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit, IconEye } from '@tabler/icons-react';
import DeleteConfirmPopover from '../../../../../components/DeleteConfirmPopover';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { EntityTypeType } from '../../../../../models/core/cache.type';
import { Permission } from '../../../../../models/core/departments.type';
import { EntitySearchResponseType } from '../../../../../models/core/entities.type';
import theme from '../../../../../theme';
import { validate } from '../../../../../utils/permission.utils';

type DataViewActionProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  entityTypeData: EntityTypeType[];
  item: EntitySearchResponseType;
  confirmActionResult(item: EntitySearchResponseType, action: string, confirmed: boolean): void;
};

export default function DataViewActions(props: DataViewActionProps) {
  const [currentUser] = useCurrentUser();

  return (
    <Group>
      {validate(Permission.EntityView, currentUser.permissoes) && (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Visualizar">
          <ActionIcon
            size="sm"
            radius="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.primary?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult(props.item, 'visualizar', true);
            }}
          >
            <IconEye size={15} color={theme?.colors?.primary?.[6]} />
          </ActionIcon>
        </Tooltip>
      )}
      {validate(Permission.EntityEdit, currentUser.permissoes) && (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
          <ActionIcon
            size="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.accent?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult(props.item, 'editar', true);
            }}
          >
            <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
          </ActionIcon>
        </Tooltip>
      )}
      {validate(Permission.EntityDelete, currentUser.permissoes) && (
        <DeleteConfirmPopover
          label="Excluir"
          message="Esta ação removerá a entidade."
          variant="outline"
          onConfirm={() => {
            props.confirmActionResult(props.item, 'excluir', true);
          }}
          onCancel={() => {
            props.confirmActionResult(props.item, 'excluir', false);
          }}
        />
      )}
    </Group>
  );
}
